import { createContext, useContext, ReactNode } from "react";
import { WorkspaceStoreInterface } from "../model/workspace.types";
import { useWorkspaceStore } from "../lib/workspace.store";

const WorkspaceContext = createContext<WorkspaceStoreInterface | null>(null);

export const WorkspaceProvider = ({ children }: { children: ReactNode }) => {
  const store = useWorkspaceStore();
  return (
    <WorkspaceContext.Provider value={store}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export const useWorkspaceContext = () => {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) throw new Error("useWorkspaceContext must be used within WorkspaceProvider");
  return ctx;
};
